var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEMaxHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 739.8 240.8",
    style: {
      enableBackground: "new 0 0 739.8 240.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#00C3FF;}\n\t.st2{fill:#1847C6;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,105.8c-75,54.7,13.6,68.4,160.2,15.3C90.4,219.3-72,163,75.1,105.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.8427,
    y1: 237.1668,
    x2: 187.8427,
    y2: 17.8221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D9E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1847C6"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.6,185.5c10.1-0.9,20.2-2.4,30.2-4.4c15,17.7,37.3,29,62.4,29c40,0,97-38.9,108.3-72.6 c-4.6,55.8-51.3,99.7-108.3,99.7C148,237.2,113.7,216.5,94.6,185.5 M187.1,46.9c22.5,0,42.9,9.1,57.7,23.9 c22.4,24,15.6,75-70.9,97.1c1.4-0.4,3.4,0,4.9-0.1c1.7-0.1,3.5-0.1,5.2-0.3c3.5-0.2,7.1-0.6,10.6-1.1c7.2-1,14.3-2.4,21.3-4.3 c13.7-3.7,27-9,39-16.6c10.5-6.6,20.2-15.2,26.1-26.3c9.7-18.1,4.5-38.7-6.4-54.9c-10.3-15.4-25-27.7-41.7-35.8 c-18.9-9.2-40.5-12.7-61.2-9.7c-19.4,2.8-37.9,11.4-52.7,24.2c-14.7,12.6-26.5,28.6-32.8,47c-2,5.8-3.5,11.9-4.5,18 c-1.1,6.5-1.6,13.2-1.6,19.8c0,4.8,0.2,10.3,0.9,15c9,0.5,16.8-0.2,25.6-1.1c-0.7-4.3-1.1-8.7-1.1-13.2 C105.6,83.4,142.1,46.9,187.1,46.9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 323.3,
    y1: 137.7,
    x2: 728.3,
    y2: 137.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.3,
    y: 136.2,
    width: 405,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 323.3,
    y1: 155.2,
    x2: 728.3,
    y2: 155.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.3,
    y: 153.7,
    className: "st1",
    width: 405,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 323.3,
    y1: 146.4,
    x2: 728.3,
    y2: 146.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.3,
    y: 145,
    className: "st2",
    width: 405,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.2,169.4V224h-3.6v-54.6H327.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.3,224v-54.6h3.4l19.8,32.2c4.1,6.8,7.1,11.9,9.6,17.2l0.2-0.1c-0.5-7.4-0.6-13.6-0.6-22.2v-27.1h3.5 V224h-3.3l-19.4-31.8c-3.8-6.3-7.2-12.1-9.9-17.7l-0.2,0.1c0.4,6.7,0.5,12.6,0.5,21.7V224H342.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.8,172.6h-16.6v-3.2H423v3.2h-16.6V224h-3.6V172.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.9,196.9h-20.3v23.9h22.7v3.2H431v-54.6h25.1v3.2h-21.5v21h20.3V196.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M468.9,170.2c3.2-0.8,7.5-1.2,11-1.2c6.6,0,10.9,1.5,13.7,4.6c2.2,2.2,3.5,5.8,3.5,9.6 c0,7.4-4.1,12.1-10,14.3v0.2c4.1,1.4,6.6,5.5,7.8,11.6c1.7,8.5,2.7,12.6,3.8,14.7h-3.7c-0.8-1.6-1.9-6.4-3.2-13.3 c-1.6-7.9-4.7-11.4-11.5-11.7h-7.9v25h-3.6V170.2z M472.5,195.8h8.1c7.8,0,13-4.7,13-11.9c0-8.3-5.7-11.7-13.7-11.7 c-3.5,0-6,0.4-7.3,0.7V195.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.9,204.9l-6.3,19.1h-3.7l18.4-54.6h3.5L546,224h-3.7l-6.4-19.1H515.9z M534.9,201.6l-6.2-18.2 c-1.3-3.8-2-6.6-2.6-9.6h-0.2c-0.7,3.2-1.5,6-2.6,9.5l-6.2,18.4H534.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M590.4,222.1c-2.6,1.4-7.5,2.8-13.7,2.8c-12.3,0-24-8.4-24-27.8c0-16.2,9.7-28.5,25.8-28.5 c6.5,0,10.3,1.5,11.8,2.4l-1.1,3.2c-2.6-1.4-6.3-2.3-10.6-2.3c-13.7,0-22.1,9.6-22.1,25.3c0,14.8,7.8,24.4,21.5,24.4 c4.3,0,8.5-1,11.5-2.5L590.4,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M614.2,172.6h-16.6v-3.2h36.8v3.2h-16.6V224h-3.6V172.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M646,169.4V224h-3.6v-54.6H646z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M671.9,224L655,169.4h3.8l9,29.2c2.4,7.9,4.5,14.8,6,20.9h0.2c1.5-6.2,3.8-13.2,6.5-20.9l9.9-29.2h3.8 L675.3,224H671.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M726.2,196.9h-20.3v23.9h22.7v3.2h-26.3v-54.6h25.1v3.2h-21.5v21h20.3V196.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.9,74.1h22v20.2h-22V74.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M468.3,93.9v30.6c0,1-0.9,1.9-1.9,1.9h-16.8c-1,0-1.9-0.9-1.9-1.9l1.2-49.5l-1.2-49.5c0-1,0.9-1.9,1.9-1.9H476 c1.2,0,2.2,0.7,2.6,1.8l27.2,73.5l25.8-73.5c0.3-1,1.3-1.8,2.5-1.8h24.6c1,0,1.9,0.9,1.9,1.9l-1.2,49.5l1.2,49.5 c0,1-0.9,1.9-1.9,1.9h-19c-1,0-1.9-0.9-1.9-1.9V93.9l0.7-35.3l0.1-4.7l-25,70.7c-0.3,1-1.3,1.8-2.5,1.8h-13.8 c-1.2,0-2.2-0.7-2.6-1.8l-27.4-73.9l0.3,8.2L468.3,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.9,126.4c-1,0-1.9-0.9-1.9-1.9l0.3-6.9c-5.3,6.5-12.8,10.3-22.4,10.3c-21.5,0-32.8-17-32.8-39.1 c0-21.9,12.7-39.5,33.3-39.5c9.4,0,16.8,3.4,21.9,9.6l-0.3-6.2c-0.1-1,0.7-1.9,1.8-1.9h18.7c1,0,1.9,0.9,1.9,1.9l-0.9,36 l0.9,35.8c0,1-0.9,1.9-1.9,1.9H628.9z M611.1,113.1c10.7,0,16.5-8.1,16.6-24.1c0.1-16.2-5.6-25-16.2-25.1 c-11.2-0.3-16.9,8.1-16.9,23.7C594.6,104.6,600.5,113.3,611.1,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.3,126.4c-1.2,0-2.2-0.7-2.8-1.8L691,99.8l-13.2,25c-0.6,0.9-1.6,1.6-2.8,1.6h-19c-0.9,0-1.3-0.9-0.9-1.6L677.2,87 l-21-34.7c-0.4-0.7,0-1.6,0.9-1.6h20.9c1.2,0,2.2,0.7,2.8,1.8l12.4,23.7l11.8-23.7c0.6-1,1.6-1.8,2.8-1.8H726 c0.9,0,1.3,0.9,0.9,1.6l-20.3,34.8l21.8,37.6c0.3,0.7-0.1,1.6-1,1.6H706.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325.2,128.7c-1,0-1.9-0.9-1.9-1.9l1.3-49.9L323.3,27c0-1,0.9-1.9,1.9-1.9h69c1,0,1.9,0.9,1.9,1.9v12.9 c0,1-0.9,1.9-1.9,1.9h-47.4l-1.2,23.8h44.3c1,0,1.9,0.9,1.9,1.9v12.9c0,1-0.9,1.9-1.9,1.9h-44.3l1.2,29.6h48.6 c1,0,1.9,0.9,1.9,1.9v12.9c0,1-0.9,1.9-1.9,1.9H325.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMaxHorizontal);
export default __webpack_public_path__ + "static/media/E-MaxHorizontal.1bdfc83846809b3582e9dd555c9c18d5.svg";
export { ForwardRef as ReactComponent };